import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { readSchools } from '../../../store/actions/schoolActions';
import { fetchLogo  } from '../../../store/actions/logoActions';

const BonafideCertificate = ({ studentName, className, admissionDate, currentDate, purpose }) => {

    const dispatch = useDispatch();
    const { schools, loading, error } = useSelector((state) => state.schoolDetails);
    const { logoUrl } = useSelector((state) => state.logo);
  
    useEffect(() => {
      dispatch(readSchools());
      dispatch(fetchLogo());
    }, [dispatch]);
  
    const institutionName = schools[0].school_name;
    const location = schools[0].school_address;
    const city = schools[0].city;
    const state = schools[0].state;
    const zip = schools[0].postal_code;
    const headTeacherName = schools[0].head_teacher_name;
  
    const logo = logoUrl;

    const styles = {
        certificateContainer: {
            width: '80%',
            margin: '0 auto',
            padding: '2rem',
            border: '1px solid #ddd',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'center',
            color: '#333',
            position: 'relative',
            backgroundColor: '#fff',
        },
        watermark: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            opacity: 0.1,
            width: '45%',
            height: 'auto',
            zIndex: 0,
        },
        institutionName: {
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '0.5rem',
        },
        address: {
            fontSize: '1rem',
            color: '#555',
            marginBottom: '2rem',
        },
        certificateTitle: {
            fontSize: '1.8rem',
            fontWeight: 'bold',
            margin: '1.5rem 0',
            color: '#4b4b4b',
        },
        certificateBody: {
            fontSize: '1.1rem',
            color: '#333',
            lineHeight: '1.6',
            textAlign: 'left',
            margin: '0 auto',
            maxWidth: '90%',
            zIndex: 1,
        },
        signatureContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '3rem',
            textAlign: 'center',
        },
        signatureBlock: {
            fontSize: '1rem',
            color: '#333',
            textAlign: 'center',
            zIndex: 1,
        },
        signatureLine: {
            display: 'block',
            margin: '1rem 0 0.5rem',
            borderTop: '1px solid #333',
            width: '200px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    };

    return (
        <div style={styles.certificateContainer}>
            {/* Optional Watermark */}
            <img src={logo} alt="Watermark Logo" style={styles.watermark} />

            <div style={styles.institutionName}>{institutionName}</div>
            <div style={styles.address}>{location}, {city}, {state}-{zip}</div>
            <div style={styles.certificateTitle}>Bonafide Certificate</div>
            
            <div style={styles.certificateBody}>
                <p>This is to certify that <strong>{studentName}</strong>, currently studying in class <strong>{className}</strong>, 
                was admitted to our institution on <strong>{admissionDate}</strong>.</p>
                <p>This certificate is issued upon their request for the purpose of <strong>{purpose}</strong>.</p>
                <p>Issued on: <strong>{currentDate}</strong></p>
            </div>
            
            <div style={styles.signatureContainer}>
                <div style={styles.signatureBlock}>
                    <span style={styles.signatureLine}></span>
                    <div>Dr. {headTeacherName}</div>
                    <small>Head of Institution</small>
                </div>
            </div>
        </div>
    );
};

export default BonafideCertificate;
